export default __webpack_public_path__ + "static/media/columns.2310356e.svg";